import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[appSuperscript]'
})
export class SuperscriptDirective implements OnInit {

  constructor(private elem: ElementRef, private renderer: Renderer2) {

  }
  ngOnInit() {
    const newString = this.elem.nativeElement.innerHTML.replaceAll('®', '<sup>®</sup>');
    this.renderer.setProperty(this.elem.nativeElement, 'innerHTML', newString);
  }


}
